module.exports = __webpack_public_path__ + "media/images/canvas_logo_red_16-4ece6890ec0a235003f0429a8f7c7bc9.png";